const questionBankData = {
  schoolWise: {
    "tigps-kolaghat": {
      schoolName: "TIGPS-Kolaghat",
      classes: {
        "Class V": [
          { subject: "Bengali", file: "bengali.pdf" },
          { subject: "Computer", file: "computer.pdf" },
          { subject: "English", file: "english.pdf" },
          { subject: "Hindi", file: "hindi.pdf" },
          { subject: "Mathematics", file: "mathematics.pdf" },
          { subject: "Science", file: "science.pdf" },
          { subject: "Social science", file: "social-science.pdf" }
        ],
        "Class VI": [
          { subject: "Bengali", file: "bengali.pdf" },
          { subject: "Computer", file: "computer.pdf" },
          { subject: "English", file: "english.pdf" },
          { subject: "Hindi", file: "hindi.pdf" },
          { subject: "Mathematics", file: "mathematics.pdf" },
          { subject: "Science", file: "science.pdf" },
          { subject: "Social science", file: "social-science.pdf" }
        ],
        "Class VII": [
          { subject: "Bengali", file: "bengali.pdf" },
          { subject: "Computer", file: "computer.pdf" },
          { subject: "English", file: "english.pdf" },
          { subject: "Hindi", file: "hindi.pdf" },
          { subject: "Mathematics", file: "mathematics.pdf" },
          { subject: "Science", file: "science.pdf" },
          { subject: "Social science", file: "social-science.pdf" }
        ],
        "Class VIII": [
          { subject: "Bengali", file: "bengali.pdf" },
          { subject: "Computer", file: "computer.pdf" },
          { subject: "English", file: "english.pdf" },
          { subject: "Hindi", file: "hindi.pdf" },
          { subject: "Mathematics", file: "mathematics.pdf" },
          { subject: "Science", file: "science.pdf" },
          { subject: "Social science", file: "social-science.pdf" }
        ],
        "Class IX": [
          { subject: "Bengali", file: "bengali.pdf" },
          { subject: "AI", file: "ai.pdf" },
          { subject: "English", file: "english.pdf" },
          { subject: "Hindi", file: "hindi.pdf" },
          { subject: "Mathematics", file: "mathematics.pdf" },
          { subject: "Science", file: "science.pdf" },
          { subject: "Social science", file: "social-science.pdf" }
        ],
        "Class X": [
          { subject: "Bengali", file: "bengali.pdf" },
          { subject: "AI", file: "ai.pdf" },
          { subject: "English", file: "english.pdf" },
          { subject: "Hindi", file: "hindi.pdf" },
          { subject: "Mathematics", file: "mathematics.pdf" },
          { subject: "Science", file: "science.pdf" },
          { subject: "Social science", file: "social-science.pdf" }
        ]
      }
    },

    "tigps-krishnanagar": {
      schoolName: "TIGPS-Krishnanagar",
      classes: {
        "Class V": [
          { subject: "Second language (Bengali)", file: "bengali-second-language.pdf" },
          { subject: "Third language (Bengali)", file: "bengali-third-language.pdf" },
          { subject: "English language", file: "english-language.pdf" },
          { subject: "English literature", file: "english-literature.pdf" },
          { subject: "EVS", file: "evs.pdf" },
          { subject: "Mathematics", file: "mathematics.pdf" },
          { subject: "Science", file: "science" },
        ],
        "Class VI": [
          { subject: "Second language (Bengali)", file: "bengali-second-language.pdf" },
          { subject: "Third language (Bengali)", file: "bengali-third-language.pdf" },
          { subject: "English language", file: "english-language.pdf" },
          { subject: "English literature", file: "english-literature.pdf" },
          { subject: "English literature poorvi (NCRT)", file: "english-literature-poorvi-ncrt.pdf"},
          { subject: "Physics", file: "physics.pdf" },
          { subject: "Chemistry", file: "chemistry.pdf"},
          { subject: "Biology", file: "biology.pdf"},
          { subject: "Mathematics", file: "mathematics.pdf"},
          { subject: "Civics", file: "civics.pdf" },
          { subject: "Geography", file: "geography.pdf" },
          { subject: "History", file: "history" },
        ],
        "Class VII": [
          { subject: "Second language (Bengali)", file: "bengali-second-language.pdf" },
          { subject: "Third language (Bengali)", file: "bengali-third-language.pdf" },
          { subject: "English language", file: "english-language.pdf" },
          { subject: "English literature", file: "english-literature.pdf" },
          { subject: "Physics", file: "physics.pdf" },
          { subject: "Chemistry", file: "chemistry.pdf"},
          { subject: "Biology", file: "biology.pdf"},
          { subject: "Mathematics", file: "mathematics.pdf"},
          { subject: "Civics", file: "civics.pdf" },
          { subject: "Geography", file: "geography.pdf" },
          { subject: "History", file: "history" },
        ],
        "Class VIII": [
          { subject: "Second language (Bengali)", file: "bengali-second-language.pdf" },
          { subject: "Third language (Bengali)", file: "bengali-third-language.pdf" },
          { subject: "English language", file: "english-language.pdf" },
          { subject: "English literature", file: "english-literature.pdf" },
          { subject: "Physics", file: "physics.pdf" },
          { subject: "Chemistry", file: "chemistry.pdf"},
          { subject: "Biology", file: "biology.pdf"},
          { subject: "Mathematics", file: "mathematics.pdf"},
          { subject: "Civics", file: "civics.pdf" },
          { subject: "Geography", file: "geography.pdf" },
          { subject: "History", file: "history" },
        ],
        "Class IX": [
          { subject: "Second language (Bengali)", file: "bengali-second-language.pdf" },
          { subject: "English language", file: "english-language.pdf" },
          { subject: "English literature (Beehive)", file: "english-literature-beehive.pdf" },
          { subject: "English literature (Moments)", file: "english-literature-moments.pdf" },
          { subject: "Physics", file: "physics.pdf" },
          { subject: "Chemistry", file: "chemistry.pdf"},
          { subject: "Biology", file: "biology.pdf"},
          { subject: "Mathematics", file: "mathematics.pdf"},
          { subject: "Political science", file: "political-science.pdf" },
          { subject: "Economics", file: "economics.pdf"},
          { subject: "Geography", file: "geography.pdf" },
          { subject: "History", file: "history" },
        ],
        "Class X": [
          { subject: "Second language (Bengali)", file: "bengali-second-language.pdf" },
          { subject: "English language", file: "english-language.pdf" },
          { subject: "English literature (First Flight)", file: "english-literature-first-flight.pdf" },
          { subject: "English literature (Footprints)", file: "english-literature-footprints.pdf" },
          { subject: "Physics", file: "physics.pdf" },
          { subject: "Chemistry", file: "chemistry.pdf"},
          { subject: "Biology", file: "biology.pdf"},
          { subject: "Mathematics", file: "mathematics.pdf"},
          { subject: "Political science", file: "political-science.pdf" },
          { subject: "Economics", file: "economics.pdf"},
          { subject: "Geography", file: "geography.pdf" },
          { subject: "History", file: "history" },
        ],
      }
    },

    "tigps-alipurduar": {
      schoolName: "TIGPS-Alipurduar",
      classes: {
        "Class III": [
          { subject: "Bengali - বাঘশিকার", file: "bengali-বাঘশিকার.pdf" },
          { subject: "Bengali - রাজার ব্যয়াম", file: "bengali-রাজারব্যয়াম.pdf" },
          { subject: "Hindi", file: "hindi.pdf" }
        ],
        "Class IV": [
          { subject: "Bengali - অতি কিশোরের ছড়া", file: "bengali-অতি-কিশোরের-ছড়া.pdf" },
          { subject: "Hindi - दोस्त की पोशाक", file: "hindi-दोस्त-की-पोशाक.pdf" },
        ],
        "Class V": [
          { subject: "English Communicative - Three Men in a Boat", file: "english-communicative-three-men-in-a-boat.pdf" },
          { subject: "Bengali - কাবুলিওয়ালা", file: "bengali-কাবুলিওয়ালা.pdf" },
          { subject: "Bengali- গনেশ জননী", file: "bengali-গনেশ-জননী.pdf" },
          { subject: "Hindi (second-language - एक माँ की बेबसी)", file: "hindi-second-language-एक माँ की बेबसी.pdf" },
          { subject: "Hindi (third-language - फूली रोटी)", file: "hindi-third-language-फूली-रोटी.pdf" },
          { subject: "Mathematics - Areas", file: "mathematics-areas.pdf"},
          { subject: "Mathematics - Volumes", file: "mathematics-volumes.pdf"}
        ],
        "Class VI": [
          { subject: "English Communicative - A Christmas Carol", file: "english-communicative-a-christmas-carol.pdf" },
          { subject: "English Communicative - The Superior Man", file: "english-communicative-the-superior-man.pdf" },
          { subject: "english", file: "English.pdf" },
          { subject: "Science", file: "science.pdf" },
          { subject: "Social Science", file: "social-science"}
        ],
        "Class VII": [
          { subject: "English Communicative", file: "english-communicative.pdf" },
          { subject: "Bengali - Second Language", file: "bengali-second-language.pdf" },
          { subject: "Science (Teacher name - Priyanka Ghosh)", file: "science-teacher-name-priyanka-ghosh.pdf" },
          { subject: "Science (Teacher name - Debalina Mitra)", file: "science-teacher-name-debalina-mitra.pdf" },
          { subject: "Mathematics", file: "mathematics.pdf"},
          { subject: "Geography", file: "geography.pdf" }
        ],
        "Class VIII": [
          { subject: "Bengali Second-language", file: "bengali-second-language.pdf" },
          { subject: "Biology", file: "biology.pdf" }
        ],
        "Class IX": [
          { subject: "Hindi Second-language", file: "hindi-second-language.pdf" },
          { subject: "Chemistry", file: "chemistry.pdf" },
          { subject: "Biology", file: "biology.pdf" },
          { subject: "Mathematics chapters-10-11-12", file: "mathematics-chapters-10-11-12.pdf" },
          { subject: "Social science - Geography", file: "social-science-geography.pdf"},
        ],
        "Class X": [
          { subject: "Bengali - বহুরুপী", file: "bengali-বহুরুপী.pdf" },
          { subject: "Physics - (Question bank)", file: "physics-question-bank.pdf" },
          { subject: "Physics - (Answer key)", file: "physics-answer-key.pdf" },
          { subject: "Chemistry", file: "chemistry.pdf" },
          { subject: "History", file: "history.pdf"},
        ],
        "Class XI": [
          { subject: "Hindi - Second language", file: "hindi-second-language.pdf" },
          { subject: "Computer science - Computer system overview", file: "computer-science-computer-system-overview.pdf" },
          { subject: "Computer science - Boolean logic", file: "computer-science-boolean-logic.pdf" },
          { subject: "Informatics practices - Computer system", file: "informatics-practices-computer-system.pdf" },
          { subject: "Informatics practices - Getting started with Python", file: "informatics-practices-getting-started-with-python.pdf"},
          { subject: "Informatics practices - Python fundamentals", file: "informatics-practices-python-fundamentals.pdf"},
          { subject: "Informatics practices - Data handling", file: "informatics-practices-data-handling.pdf"},
          { subject: "Informatics practices - Flow of control", file: "informatics-practices-data-handling.pdf"},
          { subject: "Biology", file: "biology.pdf"},
        ],
        "Class XII": [
          { subject: "Bengali Second-language", file: "bengali-second-language.pdf" },
          { subject: "Political science", file: "political-science.pdf" },
        ],
      }
    }
  },

  aep: {
    "Class VIII": [
      { subject: "Physics", file: "Question Bank_VIII_(Physic) 2025-26.pdf" },
      { subject: "Chemistry", file: "Question Bank_VIII_(Chemistry) 2025-26.pdf" },
      { subject: "Math", file: "Question Bank_VIII_(Math) 2025-26.pdf" },
      { subject: "Biology", file: "Question Bank_VIII_(Biology) 2025-26.pdf" }
    ],

    "Class IX": [
      { subject: "Physics", file: "QUESTION BANK_Physics_IX.pdf" },
      { subject: "Chemistry", file: "QUESTION BANK_Chemistry_IX.pdf" },
      { subject: "Math", file: "QUESTION BANK_Mathematics_IX.pdf" },
      { subject: "Biology", file: "QUESTION BANK_Biology_IX.pdf" }
    ],

    "Class X": [
      { subject: "Physics", file: "Question_Bank_X_Physics.pdf" },
      { subject: "Chemistry", file: "Question_Bank_X_Chemistry.pdf" },
      { subject: "Math", file: "Question_Bank_X_Mathematics.pdf" },
      { subject: "Biology", file: "Question_Bank_X_Biology.pdf" }
    ],

    "Class XI": [
      { subject: "Physics", file: "Question Bank_XI_Physics 2025-26.pdf" },
      { subject: "Chemistry", file: "Question Bank_XI_Chemistry 2025-26.pdf" },
      { subject: "Math", file: "Question Bank_XI_Math 2025-26.pdf" },
      { subject: "Biology", file: "Question Bank_XI_(Biology) 2025-26.pdf" }
    ],

    "Class XII": [
      { subject: "Physics", file: "Question Bank_XII_(Physic) 2025-26.pdf" },
      { subject: "Chemistry", file: "Question_Bank_XII_Chemistry.pdf" },
      { subject: "Math", file: "QUESTION BANK_Mathematics_XII_4.9.2025.pdf" },
      { subject: "Biology", file: "Question_Bank_XII_Biology.pdf" }
    ]
  },

  aepQuestionPaper: {
    "Class VIII": [
      { title: "Question bank of 10-11-2025", file: "10-11-2025 Question Bank (Class-VIII PCMB).pdf" },
      { title: "Question bank of 22-11-2025", file: "22-11-2025 Question Bank (Class-VIII PCMB).pdf" },
      { title: "Question bank of 01-12-2025", file: "01-12-2025 Question Bank (Class-VIII PCMB).pdf" },
      { title: "Question bank of 15-12-2025", file: "15-12-2025 Question Bank (Class-VIII PCMB).pdf" },
      { title: "Question bank of 30-12-2025", file: "30-12-2025 Question Bank (Class-VIII PCMB).pdf" },
      { title: "Question bank of 20-01-2026", file: "20-01-26_QB_2005_VIII.pdf" }
    ],

    "Class IX": [
      { title: "Question bank of 10-11-2025", file: "10-11-2025 Question Bank (Class-IX PCMB).pdf" },
      { title: "Question bank of 22-11-2025", file: "22-11-2025 Question Bank (Class-IX PCMB).pdf" },
      { title: "Question bank of 01-12-2025", file: "01-12-2025 Question Bank (Class-IX PCMB).pdf" },
      { title: "Question bank of 15-12-2025", file: "15-12-2025 Question Bank (Class-IX PCMB).pdf" },
      { title: "Question bank of 30-12-2025", file: "30-12-2025 Question Bank (Class-IX PCMB).pdf" },
      { title: "Question bank of 20-01-2026", file: "20-01-26_QB_PCMB_IX.pdf" }
    ],

    "Class X": [
      { title: "Question bank of 10-11-2025", file: "10-11-2025 Question Bank (Class-X PCMB).pdf" },
      { title: "Question bank of 22-11-2025", file: "22-11-2025 Question Bank (Class X PCMB).pdf" },
      { title: "Question bank of 01-12-2025", file: "01-12-2025 Question Bank (Class-X PCMB).pdf" },
      { title: "Question bank of 15-12-2025", file: "15-12-2025 Question Bank (Class-X PCMB).pdf" },
      { title: "Question bank of 30-12-2025", file: "30-12-2025 Question Bank (Class-X PCMB).pdf" },
      { title: "Question bank of 20-01-2026", file: "20-01-26_QB_X.pdf" }
    ],

    "Class XI": [
      { title: "Question bank of 10-11-2025", file: "10-11-2025 Question Bank (Class-XI PCMB).pdf" },
      { title: "Question bank of 22-11-2025", file: "22-11-2025 Question Bank (Class-XI PCMB).pdf" },
      { title: "Question bank of 01-12-2025", file: "01-12-2025 Question Bank (Class-XI PCMB).pdf" },
      { title: "Question bank of 15-12-2025", file: "15-12-2025 Question Bank (Class-XI PCMB).pdf" },
      { title: "Question bank of 30-12-2025", file: "30-12-2025 Question Bank (Class-XI PCMB).pdf" },
      { title: "Question bank of 20-01-2026", file: "20-01-26_QB_XI.pdf" },
      { title: "Question bank of 17-02-2026", file: "17-2-26_Q_Bank_ Math_(Class-XI)_Ch-1_Set_Theory.pdf" }
    ],

    "Class XII": [
      { title: "Question bank of 10-11-2025", file: "10-11-2025 Question Bank (Class-XII PCMB).pdf" },
      { title: "Question bank of 22-11-2025", file: "22-11-2025 Question Bank (Class-XII PCMB).pdf" },
      { title: "Question bank of 01-12-2025", file: "01-12-2025 Question Bank (Class-XII PCMB).pdf" },
      { title: "Question bank of 15-12-2025", file: "15-12-2025 Question Bank (Class-XII PCMB).pdf" },
      { title: "Question bank of 30-12-2025", file: "30-12-2025 Question Bank (Class-XII PCMB).pdf" },
      { title: "Question bank of 20-01-2026", file: "20-01-26_QB_PCMB_XII.pdf" },
      { title: "Question bank of 17-02-2026", file: "17-2-26_Q_Bank_ Math_(Class-XII)_Ch-5_Continuity_Differntiability.pdf"}
    ]
  }
};

export default questionBankData;
